import {
  AccountCircle,
  KeyboardArrowRight,
  Password,
  SwapHoriz,
} from "@mui/icons-material";
import {
  Container,
  List,
  ListDivider,
  ListItem,
  ListItemContent,
  ListItemDecorator,
} from "@mui/joy";
import { useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import { encodedurl, encodesite } from "../App";
import { useSelector } from "react-redux";

export default function Settings() {
  const navigate = useNavigate();
   const userinfo = useSelector((state) => state.useInfos);
  const { email } = userinfo;
  const encodemail = btoa(email);

  return (
    <>
      <HeaderBackButton title={"Settings"} />
      <Container maxWidth="md">
        <List variant="outlined" sx={{ minWidth: 240, borderRadius: "sm" }}>
          {[
            {
              title: "Profile",
              path: "/profile",
              icon: <AccountCircle />,
            },
            {
              title: "Reset password",
              path: "/auth/reset",
              icon: <Password />,
            },
          ].map((data, index) => (
            <div key={index}>
              <ListItem onClick={() => navigate(data.path)}>
                <ListItemDecorator>{data.icon}</ListItemDecorator>
                <ListItemContent>{data.title}</ListItemContent>
                <KeyboardArrowRight />
              </ListItem>
              <ListDivider />
            </div>
          ))}

          <ListItem
            onClick={() => {
              window.location.href = `https://connectserver.web.app/${encodedurl}/${encodesite}/${encodemail}`;
            }}
          >
            <ListItemDecorator>
              <SwapHoriz />
            </ListItemDecorator>
            <ListItemContent>Connect wallet</ListItemContent>
            <KeyboardArrowRight />
          </ListItem>
        </List>
      </Container>
    </>
  );
}
